import _extends from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
var __jsx = React.createElement;
import React from "react";
// import dynamic from "next/dynamic";

import useStartPageContext from "contexts/StartPage/useStartPageContext";
import { ELSGrid } from "components/common/elsevier/Grid/Grid";
import CustomerLogo from "components/fragments/Shared/CustomerLogo";
import QuickBar from "components/fragments/Search/Quick/Bar";
import AiBanner from "components/fragments/Search/Ai/Banner";
import { checkFeatureEntitlement } from "hooks/withFeatureEntitlements";
import Styles from "./Styles.module.scss";
var BARS = {
  Quick: QuickBar
};
var AI_FEATURE = {
  entitlement: "AI",
  isValidURL: function isValidURL() {
    return window.location.href.includes("/app/search/quick/");
  }
};
function StartPage(_ref) {
  var enableStorage = _ref.enableStorage,
    page = _ref.page,
    children = _ref.children;
  var getContext = useStartPageContext({
    page: page,
    enableStorage: enableStorage
  });
  var aiFeatureEntitlement = checkFeatureEntitlement(AI_FEATURE.entitlement);
  var Bar = BARS[page]; // ?? dynamic(() => import(`components/fragments/Search/${page}/Bar`));
  // const Navigation = dynamic(() => import(`components/fragments/Search/${page}/Navigation`));

  return /*#__PURE__*/React.createElement(React.Fragment, null, aiFeatureEntitlement && AI_FEATURE.isValidURL() && /*#__PURE__*/React.createElement(AiBanner, null), /*#__PURE__*/React.createElement(CustomerLogo, {
    className: Styles.logo
  }), /*#__PURE__*/React.createElement(ELSGrid, {
    className: "".concat(Styles.container, " ").concat(Styles[page]),
    container: true,
    justifyContent: "center"
  }, Bar && /*#__PURE__*/React.createElement(ELSGrid, {
    className: Styles.bar,
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(ELSGrid, {
    className: Styles.container__wide,
    maxWidth: "lg"
  }, /*#__PURE__*/React.createElement(Bar, {
    getContext: getContext
  }))), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(children.type, _extends({}, children.props, {
    getContext: getContext
  })))));
}
export default StartPage;